export default __webpack_public_path__ + "static/hero-desktop-0e171028acfdf9d1c5b3149a1ec8e948.jpg";